module.exports = __webpack_public_path__ + "statics/media/aspire-logo_black_no-claim.36f373e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/aspire-logo/aspire-logo_black_no-claim.svg
// module id = 1212
// module chunks = 138